import anime from 'animejs';
import type { HTMLAttributes } from 'react';
import { useInViewEffect } from 'react-hook-inview';

import cn from '@/helper/cn';

import Stats from '../components/stats';
import type { Stat } from '../constants/solutions';

type StatsSectionType = {
  infoTitle: string;
  stats: Stat[];
} & HTMLAttributes<HTMLDivElement>;

const StatsSection = ({
  infoTitle,
  stats,
  className,
  ...props
}: StatsSectionType) => {
  const sectionRef = useInViewEffect(
    ([entry], observer) => {
      if (entry.isIntersecting) {
        observer.unobserve(entry.target);

        anime.timeline({ loop: false }).add({
          targets: '#stats-section',
          translateY: [100, 0],
          opacity: [0, 1],
          duration: 500,
          easing: 'easeOutQuad',
        });
      }
    },
    { threshold: 0.2 },
  );
  return (
    <section
      id="stats-section"
      ref={sectionRef}
      className={cn(
        'mx-auto max-w-container px-10 pb-10 pt-12 opacity-0 lg:px-20 lg:py-24',
        className,
      )}
      {...props}
    >
      <Stats content={infoTitle} stats={stats} />
    </section>
  );
};

export default StatsSection;
